module.exports = __webpack_public_path__ + "img/basicIconOn.64fc041c.png";